import SafetyAnchorPointListPagingResultModelBase from '../_generated/modelBases/safety-anchor-point-list-paging-result-model-base';

export default class SafetyAnchorPointListPagingResultModel extends SafetyAnchorPointListPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
